module.exports = __webpack_public_path__ + "static/img/bg1.878fe68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg1.jpg
// module id = 3zrr
// module chunks = 0